import { Link } from "react-router-dom";
import { ArrowDown, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/motion";

const FLOW = ["Capital", "Risk", "ESG", "Impact"];

export default function Investment() {
  return (
    <section className="bg-ink text-white sec" data-testid="investment-section">
      <div className="wrap grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <Reveal>
            <p className="eyebrow text-gold flex items-center gap-3 mb-6">
              Responsible Investment <span className="hidden sm:block h-px w-14 bg-gold/60" />
            </p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="h-display font-bold text-[30px] sm:text-4xl lg:text-[48px] leading-[1.08]">
              Better investment decisions begin with better ESG intelligence.
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="text-mute text-[15px] leading-relaxed mt-7 max-w-lg">
              SarvaRitam supports investors and financial institutions with ESG integration, due diligence,
              responsible investment frameworks, climate risk, portfolio assessment and sustainability-related
              disclosures.
            </p>
          </Reveal>
          <Reveal delay={0.24}>
            <Link to="/services/responsible-investment" className="btn-outline-gold mt-9" data-testid="investment-cta">
              Explore Responsible Investment <ArrowUpRight size={15} />
            </Link>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="flex flex-col items-center gap-2 py-6" data-testid="investment-flow">
            {FLOW.map((f, i) => (
              <div key={f} className="flex flex-col items-center">
                <span
                  className={`h-display font-bold tracking-wide text-[26px] sm:text-3xl px-9 py-4 border ${
                    i === 2 ? "border-gold text-gold" : "border-white/15 text-white"
                  }`}
                >
                  {f}
                </span>
                {i < FLOW.length - 1 && <ArrowDown size={20} className="text-gold my-3" />}
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
